// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"840df2ec","703":"23f427c4","787":"ae97a69a"}[chunkId] + ".chunk.js";
};